import { FormattedMessage } from "react-intl";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import PlusIcon from "../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import AddQuizIcon from "../../../components/Common/SvgIcons/ManageIcons/AddQuizIcon";
import AddSurveyIcon from "../../../components/Common/SvgIcons/ManageIcons/AddSurveyIcon";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import PublishIcon from "../../../components/Common/SvgIcons/ManageIcons/PublishIcon";
import { colors } from "../../stripeColors";

export const createShotclasses = {
  label: <FormattedMessage id="Create_Shotclasses" />,
  variantLabel: <FormattedMessage id="Create_Class_Variant_lbl" />,
  editLabel: <FormattedMessage id="EDIT_UPDATESHOTCLASS" />,
  editTranscribeLabel: "Edit transcription",
  copyLabel: "Copy Shotclass",
  viewLabel: "View Shotclasses",
  variantPath: (tenantName) => `/${tenantName}/manage/createVariantShotclasses`,
  editpath: (tenantName) => `/${tenantName}/manage/editShotclasses`,
  copypath: (tenantName) => `/${tenantName}/manage/copyShotclasses`,
  viewpath: (tenantName) => `/${tenantName}/manage/viewShotclasses`,
  edittranscribepath: (tenantName) =>
    `/${tenantName}/manage/editTranscribeShotclasses`,
  path: (location, params, tenantName) =>
    location?.pathname.includes(createShotclasses.variantPath(tenantName))
      ? `${createShotclasses.variantPath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(createShotclasses.editpath(tenantName))
      ? `${createShotclasses.editpath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(createShotclasses.copypath(tenantName))
      ? `${createShotclasses.copypath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(createShotclasses.viewpath(tenantName))
      ? `${createShotclasses.viewpath(tenantName)}/${params?.shotclassId}`
      : location?.pathname.includes(
          createShotclasses.edittranscribepath(tenantName)
        )
      ? `${createShotclasses.edittranscribepath(tenantName)}/${
          params?.shotclassId
        }`
      : `/${tenantName}/manage/createShotclasses`,
  icon: AddIcon,
  navLinks: (navigate, location, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="MANAGE_SHOTCLASSES" />,
      path: `/${tenantName}/manage`,
      onClick: () => navigate(`/${tenantName}/manage`),
    },
    {
      key: 2,
      label: location?.pathname.includes(
        createShotclasses.variantPath(tenantName)
      )
        ? createShotclasses.variantLabel
        : location?.pathname.includes(createShotclasses.editpath(tenantName))
        ? createShotclasses.editLabel
        : location?.pathname.includes(createShotclasses.copypath(tenantName))
        ? createShotclasses.copyLabel
        : location?.pathname.includes(createShotclasses.viewpath(tenantName))
        ? createShotclasses.viewLabel
        : location?.pathname.includes(
            createShotclasses.edittranscribepath(tenantName)
          )
        ? createShotclasses.editTranscribeLabel
        : createShotclasses.label,
      path: `${location?.pathname}`,
      onClick: () => navigate(`${location?.pathname}`),
    },
  ],
  tiles: (navigate, location, params, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS_TEXT" />,
      path: `${createShotclasses.path(location, params, tenantName)}/details`,
      icon: (fill) => <DetailsIcon fill={fill} />,
      color: colors.green,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${createShotclasses.path(location, params, tenantName)}/details`
        ),
      formData: (formArgs) => [
        {
          key: 1,
          label: "Course Language",
          name: "Language",
          fieldName: "Value",
          fieldValue: "Locale",
          type: "select",
          labelColor: "light",
          valueArr: formArgs?.allLanguageVariant,
          defaultValue: formArgs?.allLanguageVariant[0]?.Locale,
          required: true,
          disabled: formArgs?.shotclassType === "edit",
          loading: formArgs?.getLanguagesLoader,
        },
        {
          key: 2,
          label: <FormattedMessage id="NAME_TEXT" />,
          labelMsg: "(Max : 80 Characters)",
          name: "ShotClassName",
          placeholder: "Enter Shotclass name..",
          labelColor: "light",
          onChange: formArgs?.handleNameExists,
          required: true,
          // disabled: formArgs?.shotclassType === "edit",
          loading: formArgs?.isShotclassNameExistLoader,
          maxLength: 80,
        },
        {
          key: 3,
          label: <FormattedMessage id="TRAINING_TYPE" />,
          name: "TrainingType",
          fieldName: "Name",
          fieldValue: "TypeId",
          buttonLabel: "Select Training Type",
          placeholder: "Search Training Type",
          type: "noSearchTags",
          tagType: "single",
          labelColor: "light",
          // valueArr: formArgs?.trainingTypes,
          searchTagsList: formArgs?.searchTrainingTypeList,
          // onChange: (e) => formArgs?.handleSearchTrainingType(e),
          handleTagList: (tagsList) =>
            formArgs?.setSearchTrainingTypeList(tagsList),
          required: true,
          loading: formArgs?.getTrainingTypesLoader,

          height: "4",
          searchable: true,
          subButtonLabel: "Add New",
          subButtonIcon: PlusIcon,
          handleSubButton: formArgs?.handleAddTrainingType,
          // width: "27",
          // disabled: false,
          // disabled: (formArgs?.isDistributed && formArgs?.isWebinarSelected) || formArgs?.isDistributed && !formArgs?.contentValue,
          // disabled: (formArgs?.shotclassType === "copy" && formArgs?.isWebinarSelected)
          //   ? false
          //   : (formArgs?.isDistributed && !formArgs?.contentValue),
          // isTagCheckBoxVisible: false,
          // addedTagsVisible: false,
          // Enhanced disabled condition for distributed classes
          disabled:
            // Disable completely for distributed webinar classes in edit mode
            formArgs?.disableTrainingTypeForDistributedWebinar
              ? true
              : // Original copy webinar condition
              formArgs?.shotclassType === "copy" && formArgs?.isWebinarSelected
              ? false
              : // Original distributed condition
                false,
          isTagCheckBoxVisible: false,
          addedTagsVisible: false,
        },
        {
          key: 4,
          label: <FormattedMessage id="TAG_TEXT" />,
          name: "TagsList",
          fieldName: "TagName",
          fieldValue: "TagValue",
          type: "tags",
          placeholder: "Enter Tag Here & Tap Plus Icon",
          labelColor: "light",
          required: true,
          // valueArr: tagsList,
          isValidTagSearch: formArgs?.validTagSearch,
          searchTagsList: formArgs?.searchTagsList,
          onChange: (e) => formArgs?.handleSearchTags(e),
          loading: formArgs?.getShotclassTagLoader,
          // handleTagList: (val) => setTagsList(val),
        },
        {
          key: 5,
          label: <FormattedMessage id="DESCRIPTION_TEXT" />,
          labelMsg: "(Max : 200 Characters)",
          name: "Description",
          type: "textarea",
          placeholder: "Enter Small Description about course",
          labelColor: "light",
          required: true,
          maxLength: 200,
        },
        {
          key: 6,
          label: <FormattedMessage id="SUMMARY_TEXT" />,
          labelMsg: "(Max : 500 Characters)",
          name: "Summary",
          type: "textarea",
          placeholder: "Enter Learning Key Points Here",
          labelColor: "light",
          required: true,
          maxLength: 500,
        },
        {
          key: 7,
          type: "file",
          label: <FormattedMessage id="CREATE_VIDEOCONTENT_TEXT" />,
          name: "Content.ContentValue",
          disableLabelClick: true,
          labelColor: "light",
          disabled: formArgs?.isDistributed && !formArgs?.contentValue,
          // required: true,
          required: formArgs?.isWebinarSelected, // Use the state from Details component
          hidden: true,
          fileInputView:
            (formArgs?.shotclassType === "edit" ||
              formArgs?.shotclassType === "copy" ||
              formArgs?.shotclassType === "view") &&
            !formArgs?.contentUpdated,
          handleFileInputView: () => formArgs?.handleViewContentModal(),
          fileInputDownload: formArgs?.isVideoDownload,
          handleFileInputDownload: () => formArgs?.handleDownloadVideo(),
          handleClickFileButton: () => formArgs?.setActiveSection(2),
          handleCancelFileInput: () => formArgs?.handleCancelFileContent(),
        },
        {
          key: 8,
          type: "file",
          label: <FormattedMessage id="CREATE_THUMBNAIL_TEXT" />,
          name: "ThumbnailImage",
          disableLabelClick: true,
          labelColor: "light",
          required: true,
          hidden: true,
          fileInputView:
            formArgs?.shotclassType === "edit" ||
            formArgs?.shotclassType === "copy" ||
            formArgs?.shotclassType === "view",
          handleFileInputView: false,
          handleClickFileButton: () => formArgs?.setActiveSection(3),
          handleCancelFileInput: () => formArgs?.handleCancelImage(),
        },
        {
          key: 9,
          type: "file",
          label: "Select ics File",
          name: "CalendarUrl",
          disableLabelClick: true,
          labelColor: "light",
          required: true,
          hidden: true,
          accept: ".ics",
          onChange: (e) => formArgs?.handleIcsFileUpload(e),
          handleCancelFileInput: () => formArgs?.handleCancelIcsFileContent(),
          // fileInputView:
          //   formArgs?.shotclassType === "edit" ||
          //   formArgs?.shotclassType === "copy" ||
          //   formArgs?.shotclassType === "view",
          // handleFileInputView: true,
          // handleClickFileButton: () => formArgs?.setActiveSection(3),
          // handleCancelFileInput: () => formArgs?.handleCancelImage(),
        },
      ],
    },
    {
      key: 2,
      label: "Add Quiz",
      path: `${createShotclasses.path(location, params, tenantName)}/addQuiz`,
      icon: (fill) => <AddQuizIcon fill={fill} />,
      color: colors.purple,
      isCompleted: false,
      optionalText: () => "(Optional)",
      onClick: () =>
        navigate(
          `${createShotclasses.path(location, params, tenantName)}/addQuiz`
        ),
    },
    {
      key: 3,
      label: "Add Survey",
      path: `${createShotclasses.path(location, params, tenantName)}/addSurvey`,
      icon: (fill) => <AddSurveyIcon fill={fill} />,
      color: colors.red,
      isCompleted: false,
      optionalText: () => <p>(Optional)</p>,
      onClick: () =>
        navigate(
          `${createShotclasses.path(location, params, tenantName)}/addSurvey`
        ),
    },
    {
      key: 4,
      label: "Publish Shotclass",
      path: `${createShotclasses.path(
        location,
        params,
        tenantName
      )}/publishShotclass`,
      color: colors.orange,
      isCompleted: false,
      icon: (fill) => <PublishIcon fill={fill} />,
      onClick: () =>
        navigate(
          `${createShotclasses.path(
            location,
            params,
            tenantName
          )}/publishShotclass`
        ),
      formData: (formArgs) => [
        {
          key: 1,
          label: <FormattedMessage id="SHOTCLASS_OFFLINE" />,
          name: "OfflineShotclass",
          visible: !(
            // Hide if TrainingType is "webinar" AND ContentMediaType is video or ppt
            (
              formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
                "webinar" &&
              (formArgs?.formValues?.details?.Content?.ContentMediaType === 1 ||
                formArgs?.formValues?.details?.Content?.ContentMediaType === 7)
            )
          ),
          disabled:
            (formArgs?.formValues?.details?.Content?.ContentMediaType !== 1 &&
              formArgs?.formValues?.details?.Content?.ContentMediaType !== 7) ||
            formArgs?.formValues?.Other?.IsDistributed,
          toolTipText: <FormattedMessage id="OFFLINE_HELP_MSG" />,
        },
        {
          key: 2,
          label: "Is Video Mandatory",
          name: "IsVideoMandatory",
          // visible:
          //   formArgs?.formValues?.details?.Content?.ContentMediaType === 1,
          visible:
            formArgs?.formValues?.details?.Content?.ContentMediaType === 1 &&
            !(
              formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar"
            ),
          disabled: false,
          toolTipText: formArgs?.isVideoMandatory ? (
            <>
              <FormattedMessage id="VIDEOMANDATE_HELP_MSG_CHECKED" />
            </>
          ) : (
            <>
              <FormattedMessage id="VIDEOMANDATE_HELP_MSG_UNCHECKED" />
            </>
          ),
        },
        {
          key: 3,
          label: "Allow question jumbling",
          name: "QuestionJumbling",
          visible:
            (formArgs?.formValues?.addQuiz?.TotalQuestionCount > 1 || false) &&
            !(
              formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar"
            ),
          disabled: false,
          toolTipText: formArgs?.questionJumbling ? (
            <>
              <FormattedMessage id="RANDOMQUESTION_HELP_MSG_CHECKED" />
            </>
          ) : (
            <>
              <FormattedMessage id="RANDOMQUESTION_HELP_MSG_UNCHECKED" />
            </>
          ),
        },
        {
          key: 4,
          label: <FormattedMessage id="SHOTCLASS_SHOWCORANS" />,
          name: "ShowCorrectAnswers",
          visible:
            (formArgs?.formValues?.addQuiz?.TotalQuestionCount > 0 || false) &&
            !(
              formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar"
            ),
          disabled: false,
          toolTipText: formArgs?.showCorrectAnswers ? (
            <>
              <FormattedMessage id="SHOWCORRECTANSWER_HELP_MSG_CHECKED" />
            </>
          ) : (
            <>
              <FormattedMessage id="SHOWCORRECTANSWER_HELP_MSG_UNCHECKED" />
            </>
          ),
        },
        {
          key: 5,
          label: "Learner can change answers",
          name: "CanChangeAnswers",
          visible:
            formArgs?.formValues?.addQuiz?.TotalQuestionCount > 0 &&
            !(
              formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
              "webinar"
            ),
          disabled: false,
          toolTipText: formArgs?.canChangeAnswers ? (
            <>
              <FormattedMessage id="LEARNERCHANGE_CORRECT_ANSWER_MSG_CHECKED" />
            </>
          ) : (
            <>
              <FormattedMessage id="LEARNERCHANGE_CORRECT_ANSWER_MSG_UNCHECKED" />
            </>
          ),
        },
        {
          key: 6,
          label: <FormattedMessage id="SHOTCLASS_ISSURVEYMADATORYFORUSER" />,
          name: "IsSurveyMandatory",
          visible:
            formArgs?.formValues?.addSurvey?.TotalQuestionCount === 0
              ? false
              : !(
                  formArgs?.formValues?.details?.TrainingType?.[0]?.Name?.toLowerCase() ===
                  "webinar"
                ),
          // visible: true,
          disabled: false,
          toolTipText: formArgs?.isSurveyMandatory ? (
            <FormattedMessage id="MANDATESURVEY_HELP_MSG" />
          ) : (
            "Learner can skip the survey"
          ),
        },
        {
          key: 7,
          label: <FormattedMessage id="IS_RESTRICTEDCLASS_TEXT" />,
          name: "HasRestricted",
          visible: true,
          disabled: false,
          toolTipText: (
            <>
              <FormattedMessage id="RESTRICT_TO_APPLGRPS" />
            </>
          ),
        },
        {
          key: 8,
          name: "ShotclassTargetGroupMapping",
          type: "noSearchTags",
          fieldName: "Name",
          fieldValue: "UserGroupId",
          placeholder: "Search User Group",
          height: "5",
          width: "27",
          visible: formArgs?.hasRestricted,
          loading: formArgs?.getUserGroupsLoader,
          disabled: false,
          searchable: true,
          searchTagsList: formArgs?.userGroups,
          handleTagList: (tagsList) => formArgs?.setUserGroups(tagsList),
        },
        {
          key: 9,
          label: "Enable Trend Tracking",
          name: "IsTrackingEnabled",
          visible:
            formArgs?.formValues?.addSurvey?.surveyType === "scored" &&
            formArgs?.formValues?.addSurvey?.TotalQuestionCount > 0 &&
            formArgs?.formValues?.details?.TrainingType?.[0].Name?.toLowerCase() !==
              "webinar",
          disabled: false,
          toolTipText: "Track and analyze score changes over time",
          fieldValue: "IsTrackingEnabled",
        },
        {
          key: 10,
          label: "Customize Completion Screen",
          name: "CustomizeCompletionScreen",
          type: "custom",
          visible: true,
          disabled: false,
          toolTipText: "Add custom title and description for course completion screen",
        },
      ],
    },
  ],
};
